export const mainDisplayStatus = {
  isdel: {
    id: '1',
    label: 'common_status_deleted',
  },
  enable: {
    id: '0',
    label: 'common_status_delivery',
    key: 'status',
  },
  notDelivery: {
    id: '',
    label: 'common_status_not_delivery',
  },
  notSupported: {
    id: '',
    label: 'common_status_not_supported',
  },
  paused: {
    id: '1',
    label: 'common_status_paused',
    key: 'status',
  },
  completed: {
    label: 'common_status_completed',
  },
  rfClosed: {
    label: 'common_rf_closed',
  },
  frozen: {
    label: 'common_frozen',
  },
};
